import * as R from "ramda";
import axios from "axios";
import { CATEGORY_SCHEME, ALL, CATEGORY_SCHEME_RESULTS, CATEGORY_RESULTS } from "./constants/types.mjs";
import { getRequestArgs } from "./getRequestArgs.mjs";
import { parseTreeResultsAsList } from "./parseTreeResultsAsList.mjs";
const getCategories = (args) => {
  const { url, headers, params } = getRequestArgs(
    R.pipe(
      R.assoc("type", CATEGORY_SCHEME),
      R.assoc("identifiers", { agencyId: ALL, code: ALL, version: ALL })
    )(args)
  );
  return axios.get(url, { headers, params }).then(
    (res) => parseTreeResultsAsList({
      lists: CATEGORY_SCHEME_RESULTS,
      listValues: CATEGORY_RESULTS
    })(res.data)
  );
};
export {
  getCategories
};
